import { memo, useCallback, Fragment } from 'react';
import { Options, useHotkeys } from 'react-hotkeys-hook';
import { cn } from '~/lib/utils';

export const KeyboardShortcutToken = memo(function ({
  keys,
  onShortcut,
  options,
  className,
}: {
  keys: string[] | string;
  onShortcut: () => void;
  options?: Options;
  className?: string;
}) {
  const memoizedOnShortcut = useCallback(onShortcut, [onShortcut]);

  useHotkeys(keys, memoizedOnShortcut, options || {}, [keys, options, memoizedOnShortcut]);

  return (
    <kbd className={cn('font-aspekta bg-grayscale-800 text-grayscale-200 flex rounded-sm px-1 text-xs', className)}>
      {Array.isArray(keys) ? keys.map((key, index) => <Fragment key={index}>{key}</Fragment>) : keys}
    </kbd>
  );
});
